
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9e2d8c2c!sass-loader?sourceMap!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Notificacoes.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Notificacoes.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-9e2d8c2c!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Notificacoes.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/domains/pessoal/components/minha-conta/Notificacoes.vue
// module id = 508
// module chunks = 2